export default (_, c) => {
	// locale needed later
	const proto = c.prototype;
	const oldFormat = proto.format;
	proto.format = function (formatStr) {
		const locale = this.$locale();

		if (!this.isValid()) {
			return oldFormat.bind(this)(formatStr);
		}

		const str = formatStr || "YYYY-MM-DDTHH:mm:ssZ";
		let result = str;
		if (str === "WS-DT") {
			if (locale.name === "fr") {
				result = "dddd D MMMM [à] H[h]";
			} else if (locale.name === "de") {
				result = "dddd, D. MMMM [um] H:mm [Uhr]";
			} else {
				result = "dddd, MMMM D [at] h:mm a";
			}
		}

		if (str === "WS-date-at-time") {
			if (locale.name === "fr") {
				result = "l [à] HH:mm";
			} else {
				result = "l [at] h:mm a";
			}
		}
		if (str === "WS-DMHM") {
			if (locale.name === "fr") {
				result = "D MMMM [à] H[h]mm";
			} else if (locale.name === "de") {
				result = "D. MMMM [um] H:mm [Uhr]";
			} else {
				result = "MMMM D [at] h:mm a";
			}
		}
		if (str === "WS-LD") {
			if (locale.name === "fr") {
				result = "dddd D MMM YYYY";
			} else {
				result = "ddd MMM D YYYY";
			}
		}

		if (str === "WS-RECEIVE") {
			if (locale.name === "fr") {
				result = "HH:mm [le] LL";
			} else {
				result = "HH:mm [on] LL";
			}
		}
		return oldFormat.bind(this)(result);
	};
};
